import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import { API } from '../lib/api';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found in hash');
        navigate('/');
        return;
      }

      const sessionId = sessionIdMatch[1];
      console.log('Processing auth with session_id:', sessionId.substring(0, 8) + '...');

      try {
        const response = await fetch(`${API}/auth/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        console.log('Auth session response status:', response.status);

        if (response.ok) {
          const userData = await response.json();
          console.log('Auth success, user:', userData.email);
          // Store session token for Authorization header
          if (userData.session_token) {
            localStorage.setItem('tbg_session_token', userData.session_token);
          }
          // Remove session_token from user object before setting state
          const { session_token, ...userInfo } = userData;
          setUser(userInfo);
          // Clear the hash and navigate to home
          window.history.replaceState(null, '', '/');
          navigate('/', { replace: true });
        } else {
          const errorData = await response.text();
          console.error('Session exchange failed:', response.status, errorData);
          navigate('/');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/');
      }
    };

    processAuth();
  }, [location.hash, navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto text-accent" />
        <p className="mt-4 text-muted-foreground font-ui">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
